import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import AdvisorStudentsStudentProfileTab from "./StudentTabs/AdvisorStudentsStudentProfileTab";
import AdvisorStudentsStudentActivityTab from "./StudentTabs/Activity/AdvisorStudentsStudentActivityTab";
import AdvisorStudentsStudentAlertTab from "./StudentTabs/AdvisorStudentsStudentAlertTab";
import AdvisorStudentsStudentNotesTab from "./StudentTabs/AdvisorStudentsStudentNotesTab";
import AdvisorStudentsStudentTaskTab from "./StudentTabs/AdvisorStudentsStudentTaskTab";
import AdvisorStudentsStudentSurveysTab from "./StudentTabs/AdvisorStudentsStudentSurveysTab";
import AdvisorStudentsStudentMeetingsTab from "./StudentTabs/AdvisorStudentsStudentMeetingsTab";
import AdvisorStudentsStudentPipelinesTab from "./StudentTabs/AdvisorStudentsStudentPipelinesTab";
import AdvisorStudentsCourseTab from "./StudentTabs/AdvisorStudentsStudentCoursesTab";
import AdvisorStudentsStudentTranscriptTab from "./StudentTabs/AdvisorStudentsStudentTranscriptTab";
import AdvisorStudentsTestScoresTab from "./StudentTabs/AdvisorStudentsStudentTestScoresTab";
import AdvisorStudentsStudentFinancesTab from "./StudentTabs/AdvisorStudentsStudentFinancesTab";
import AdvisorStudentsStudentApplicationsTab from "./StudentTabs/AdvisorStudentsStudentApplicationsTab";
import AdvisorStudentsProgramsTab from "./StudentTabs/AdvisorStudentsStudentProgramsTab";
import AdvisorStudentsStaffMeetingsTab from "./StaffTabs/AdvisorStudentsStaffMeetingsTab";
import AdvisorStudentsStaffSurveysTab from "./StaffTabs/AdvisorStudentsStaffSurveysTab";
import AdvisorStudentsStaffTaskTab from "./StaffTabs/AdvisorStudentsStaffTaskTab";
import AdvisorStudentsStaffNotesTab from "./StaffTabs/AdvisorStudentsStaffNotesTab";
import AdvisorStudentsStaffActivityTab from "./StaffTabs/Activity/AdvisorStudentsStaffActivityTab";
import AdvisorStudentsStaffProfileTab from "./StaffTabs/AdvisorStudentsStaffProfileTab";
import AdvisorStudentsStaffPipelinesTab from "./StaffTabs/AdvisorStudentsStaffPipelinesTab";
import AdvisorStudentsStudentDocumentsTab from "./StudentTabs/AdvisorStudentsStudentDocumentsTab";
import AdvisorStudentsStudentAnalyticsTab from "./StudentTabs/AdvisorStudentsStudentAnalyticsTab";
import { Features } from "../../../Domain/Feature/Feature.model";
import FeatureService from "../../../Domain/Feature/Feature.service";
import LimitedPermissionUtility from "../../../../util/LimitedPermissionUtility";
import AdvisorStudentsStudentMessagesTab from "./StudentTabs/AdvisorStudentsStudentMessagesTab";
import AdvisorStudentsStudentFormsTab from "./StudentTabs/AdvisorStudentsStudentFormsTab";
import AdvisorStudentsStaffFormsTab from "./StaffTabs/AdvisorStudentsStaffFormsTab";
const shouldSeeTab = (name, tabVisibility) => {
    return FeatureService.shouldShowFeature(name, tabVisibility);
};
const canSeeTab = (item, tabPermissions, userIsOnCase, canSeeFullProfileForAllStudents, canSeeFullProfileForMyCaseload) => {
    return LimitedPermissionUtility.canSeeTab({
        tab: item,
        tabPermissions,
        userIsOnCase,
        canSeeFullProfileForAllStudents,
        canSeeFullProfileForMyCaseload,
    });
};
const getVisibleTabs = ({ visibleUser, opportunity, visibleUserActions, type, tabPermissions, tabVisibility, userIsOnCase, canSeeFullProfileForAllStudents, canSeeFullProfileForMyCaseload, }) => {
    switch (type) {
        case "Staff":
            return [
                // @ts-expect-error - TS2322 - Type '{ tab: string; content: Element; id: string; } | null' is not assignable to type 'undefined'.
                canSeeTab("profile", tabPermissions, userIsOnCase, 
                // @ts-expect-error - TS2345 - Argument of type 'boolean | null | undefined' is not assignable to parameter of type 'boolean'.
                canSeeFullProfileForAllStudents, canSeeFullProfileForMyCaseload) && shouldSeeTab(Features.PROFILE_PROFILE, tabVisibility)
                    ? {
                        tab: "Profile",
                        content: (_jsx(AdvisorStudentsStaffProfileTab, { student: visibleUser, setStudent: visibleUserActions.edit })),
                        id: "Profile",
                    }
                    : null,
                // @ts-expect-error - TS2322 - Type '{ tab: string; content: Element; id: string; } | null' is not assignable to type 'undefined'.
                canSeeTab("activity", tabPermissions, userIsOnCase, 
                // @ts-expect-error - TS2345 - Argument of type 'boolean | null | undefined' is not assignable to parameter of type 'boolean'.
                canSeeFullProfileForAllStudents, canSeeFullProfileForMyCaseload) && shouldSeeTab(Features.PROFILE_ACTIVITY, tabVisibility)
                    ? {
                        tab: "Activity",
                        content: (_jsx(AdvisorStudentsStaffActivityTab, { student: visibleUser, opportunity: opportunity })),
                        id: "Activity",
                    }
                    : null,
                // @ts-expect-error - TS2322 - Type '{ tab: string; content: Element; id: string; } | null' is not assignable to type 'undefined'.
                canSeeTab("notes", tabPermissions, userIsOnCase, 
                // @ts-expect-error - TS2345 - Argument of type 'boolean | null | undefined' is not assignable to parameter of type 'boolean'.
                canSeeFullProfileForAllStudents, canSeeFullProfileForMyCaseload) && shouldSeeTab(Features.PROFILE_NOTES, tabVisibility)
                    ? {
                        tab: "Notes",
                        content: _jsx(AdvisorStudentsStaffNotesTab, { student: visibleUser }),
                        id: "Notes",
                    }
                    : null,
                // @ts-expect-error - TS2322 - Type '{ tab: string; content: Element; id: string; } | null' is not assignable to type 'undefined'.
                canSeeTab("tasks", tabPermissions, userIsOnCase, 
                // @ts-expect-error - TS2345 - Argument of type 'boolean | null | undefined' is not assignable to parameter of type 'boolean'.
                canSeeFullProfileForAllStudents, canSeeFullProfileForMyCaseload) && shouldSeeTab(Features.PROFILE_TASKS, tabVisibility)
                    ? {
                        tab: "Tasks",
                        content: _jsx(AdvisorStudentsStaffTaskTab, { student: visibleUser }),
                        id: "Tasks",
                    }
                    : null,
                // @ts-expect-error - TS2322 - Type '{ tab: string; content: Element; id: string; } | null' is not assignable to type 'undefined'.
                canSeeTab("surveys", tabPermissions, userIsOnCase, 
                // @ts-expect-error - TS2345 - Argument of type 'boolean | null | undefined' is not assignable to parameter of type 'boolean'.
                canSeeFullProfileForAllStudents, canSeeFullProfileForMyCaseload) && shouldSeeTab(Features.PROFILE_SURVEYS, tabVisibility)
                    ? {
                        tab: "Surveys",
                        content: _jsx(AdvisorStudentsStaffSurveysTab, { student: visibleUser }),
                        id: "Surveys",
                    }
                    : null,
                // @ts-expect-error - TS2322 - Type '{ tab: string; content: Element; id: string; } | null' is not assignable to type 'undefined'.
                canSeeTab("meetings", tabPermissions, userIsOnCase, 
                // @ts-expect-error - TS2345 - Argument of type 'boolean | null | undefined' is not assignable to parameter of type 'boolean'.
                canSeeFullProfileForAllStudents, canSeeFullProfileForMyCaseload) && shouldSeeTab(Features.PROFILE_MEETINGS, tabVisibility)
                    ? {
                        tab: "Meetings",
                        content: (_jsx(AdvisorStudentsStaffMeetingsTab, { student: visibleUser })),
                        id: "Meetings",
                    }
                    : null,
                // @ts-expect-error - TS2322 - Type '{ tab: string; content: Element; id: string; } | null' is not assignable to type 'undefined'.
                canSeeTab("documents", tabPermissions, userIsOnCase, 
                // @ts-expect-error - TS2345 - Argument of type 'boolean | null | undefined' is not assignable to parameter of type 'boolean'.
                canSeeFullProfileForAllStudents, canSeeFullProfileForMyCaseload) && shouldSeeTab(Features.PROFILE_DOCS, tabVisibility)
                    ? {
                        tab: "Docs",
                        content: (_jsx(AdvisorStudentsStudentDocumentsTab, { student: visibleUser })),
                        id: "Docs",
                    }
                    : null,
                // @ts-expect-error - TS2322 - Type '{ tab: string; content: Element; id: string; } | null' is not assignable to type 'undefined'.
                canSeeTab("pipelines", tabPermissions, userIsOnCase, 
                // @ts-expect-error - TS2345 - Argument of type 'boolean | null | undefined' is not assignable to parameter of type 'boolean'.
                canSeeFullProfileForAllStudents, canSeeFullProfileForMyCaseload) && shouldSeeTab(Features.PROFILE_PIPELINES, tabVisibility)
                    ? {
                        tab: "Pipelines",
                        content: (
                        // @ts-expect-error - TS2741 - Property 'opportunity' is missing in type '{ student: PersonFullDto; }' but required in type '{ student: PersonFullDto; opportunity: Opportunity[] | null | undefined; }'.
                        _jsx(AdvisorStudentsStaffPipelinesTab, { student: visibleUser })),
                        id: "Pipelines",
                    }
                    : null,
                // @ts-expect-error - TS2322 - Type '{ tab: string; content: Element; id: string; } | null' is not assignable to type 'undefined'.
                canSeeTab("forms", tabPermissions, userIsOnCase, 
                // @ts-expect-error - TS2345 - Argument of type 'boolean | null | undefined' is not assignable to parameter of type 'boolean'.
                canSeeFullProfileForAllStudents, canSeeFullProfileForMyCaseload) && shouldSeeTab(Features.PROFILE_FORMS, tabVisibility)
                    ? {
                        tab: "Forms",
                        content: (_jsx(AdvisorStudentsStaffFormsTab, { student: visibleUser, 
                            // @ts-expect-error - TS2322 - Type 'Opportunity | null | undefined' is not assignable to type 'Opportunity[] | null | undefined'.
                            opportunity: opportunity })),
                        id: "Forms",
                    }
                    : null,
            ];
        case "Student":
        default:
            return [
                // @ts-expect-error - TS2322 - Type '{ tab: string; content: Element; id: string; } | null' is not assignable to type 'undefined'.
                canSeeTab("profile", tabPermissions, userIsOnCase, 
                // @ts-expect-error - TS2345 - Argument of type 'boolean | null | undefined' is not assignable to parameter of type 'boolean'.
                canSeeFullProfileForAllStudents, canSeeFullProfileForMyCaseload) && shouldSeeTab(Features.PROFILE_PROFILE, tabVisibility)
                    ? {
                        tab: "Profile",
                        content: (_jsx(AdvisorStudentsStudentProfileTab, { student: visibleUser, setStudent: visibleUserActions.edit, onCase: userIsOnCase })),
                        id: "Profile",
                    }
                    : null,
                // @ts-expect-error - TS2322 - Type '{ tab: string; content: Element; id: string; } | null' is not assignable to type 'undefined'.
                canSeeTab("activity", tabPermissions, userIsOnCase, 
                // @ts-expect-error - TS2345 - Argument of type 'boolean | null | undefined' is not assignable to parameter of type 'boolean'.
                canSeeFullProfileForAllStudents, canSeeFullProfileForMyCaseload) && shouldSeeTab(Features.PROFILE_ACTIVITY, tabVisibility)
                    ? {
                        tab: "Activity",
                        content: (_jsx(AdvisorStudentsStudentActivityTab, { student: visibleUser, opportunity: opportunity })),
                        id: "Activity",
                    }
                    : null,
                // @ts-expect-error - TS2322 - Type '{ tab: string; content: Element; id: string; } | null' is not assignable to type 'undefined'.
                canSeeTab("alerts", tabPermissions, userIsOnCase, 
                // @ts-expect-error - TS2345 - Argument of type 'boolean | null | undefined' is not assignable to parameter of type 'boolean'.
                canSeeFullProfileForAllStudents, canSeeFullProfileForMyCaseload) && shouldSeeTab(Features.PROFILE_ALERTS, tabVisibility)
                    ? {
                        tab: "Alerts",
                        content: (_jsx(AdvisorStudentsStudentAlertTab, { student: visibleUser, opportunity: opportunity })),
                        id: "Alerts",
                    }
                    : null,
                // @ts-expect-error - TS2322 - Type '{ tab: string; content: Element; id: string; } | null' is not assignable to type 'undefined'.
                canSeeTab("notes", tabPermissions, userIsOnCase, 
                // @ts-expect-error - TS2345 - Argument of type 'boolean | null | undefined' is not assignable to parameter of type 'boolean'.
                canSeeFullProfileForAllStudents, canSeeFullProfileForMyCaseload) && shouldSeeTab(Features.PROFILE_NOTES, tabVisibility)
                    ? {
                        tab: "Notes",
                        content: (_jsx(AdvisorStudentsStudentNotesTab, { student: visibleUser, opportunity: opportunity })),
                        id: "Notes",
                    }
                    : null,
                // @ts-expect-error - TS2322 - Type '{ tab: string; content: Element; id: string; } | null' is not assignable to type 'undefined'.
                canSeeTab("messages", tabPermissions, userIsOnCase, 
                // @ts-expect-error - TS2345 - Argument of type 'boolean | null | undefined' is not assignable to parameter of type 'boolean'.
                canSeeFullProfileForAllStudents, canSeeFullProfileForMyCaseload) && shouldSeeTab(Features.PROFILE_MESSAGES, tabVisibility)
                    ? {
                        tab: "Messages",
                        content: (_jsx(AdvisorStudentsStudentMessagesTab, { student: visibleUser, opportunity: opportunity })),
                        id: "Messages",
                    }
                    : null,
                // @ts-expect-error - TS2322 - Type '{ tab: string; content: Element; id: string; } | null' is not assignable to type 'undefined'.
                canSeeTab("tasks", tabPermissions, userIsOnCase, 
                // @ts-expect-error - TS2345 - Argument of type 'boolean | null | undefined' is not assignable to parameter of type 'boolean'.
                canSeeFullProfileForAllStudents, canSeeFullProfileForMyCaseload) && shouldSeeTab(Features.PROFILE_TASKS, tabVisibility)
                    ? {
                        tab: "Tasks",
                        content: _jsx(AdvisorStudentsStudentTaskTab, { student: visibleUser }),
                        id: "Tasks",
                    }
                    : null,
                // @ts-expect-error - TS2322 - Type '{ tab: string; content: Element; id: string; } | null' is not assignable to type 'undefined'.
                canSeeTab("surveys", tabPermissions, userIsOnCase, 
                // @ts-expect-error - TS2345 - Argument of type 'boolean | null | undefined' is not assignable to parameter of type 'boolean'.
                canSeeFullProfileForAllStudents, canSeeFullProfileForMyCaseload) && shouldSeeTab(Features.PROFILE_SURVEYS, tabVisibility)
                    ? {
                        tab: "Surveys",
                        content: (_jsx(AdvisorStudentsStudentSurveysTab, { student: visibleUser })),
                        id: "Surveys",
                    }
                    : null,
                // @ts-expect-error - TS2322 - Type '{ tab: string; content: Element; id: string; } | null' is not assignable to type 'undefined'.
                canSeeTab("meetings", tabPermissions, userIsOnCase, 
                // @ts-expect-error - TS2345 - Argument of type 'boolean | null | undefined' is not assignable to parameter of type 'boolean'.
                canSeeFullProfileForAllStudents, canSeeFullProfileForMyCaseload) && shouldSeeTab(Features.PROFILE_MEETINGS, tabVisibility)
                    ? {
                        tab: "Meetings",
                        content: (_jsx(AdvisorStudentsStudentMeetingsTab, { student: visibleUser })),
                        id: "Meetings",
                    }
                    : null,
                // @ts-expect-error - TS2322 - Type '{ tab: string; content: Element; id: string; } | null' is not assignable to type 'undefined'.
                canSeeTab("courses", tabPermissions, userIsOnCase, 
                // @ts-expect-error - TS2345 - Argument of type 'boolean | null | undefined' is not assignable to parameter of type 'boolean'.
                canSeeFullProfileForAllStudents, canSeeFullProfileForMyCaseload) && shouldSeeTab(Features.PROFILE_COURSES, tabVisibility)
                    ? {
                        tab: "Courses",
                        content: _jsx(AdvisorStudentsCourseTab, { student: visibleUser }),
                        id: "Courses",
                    }
                    : null,
                // @ts-expect-error - TS2322 - Type '{ tab: string; content: Element; id: string; } | null' is not assignable to type 'undefined'.
                canSeeTab("transcript", tabPermissions, userIsOnCase, 
                // @ts-expect-error - TS2345 - Argument of type 'boolean | null | undefined' is not assignable to parameter of type 'boolean'.
                canSeeFullProfileForAllStudents, canSeeFullProfileForMyCaseload) && shouldSeeTab(Features.PROFILE_TRANSCRIPT, tabVisibility)
                    ? {
                        tab: "Transcript",
                        content: (_jsx(AdvisorStudentsStudentTranscriptTab, { student: visibleUser })),
                        id: "Transcript",
                    }
                    : null,
                // @ts-expect-error - TS2322 - Type '{ tab: string; content: Element; id: string; } | null' is not assignable to type 'undefined'.
                canSeeTab("testScores", tabPermissions, userIsOnCase, 
                // @ts-expect-error - TS2345 - Argument of type 'boolean | null | undefined' is not assignable to parameter of type 'boolean'.
                canSeeFullProfileForAllStudents, canSeeFullProfileForMyCaseload) && shouldSeeTab(Features.PROFILE_TEST_SCORES, tabVisibility)
                    ? {
                        tab: "Test Scores",
                        content: _jsx(AdvisorStudentsTestScoresTab, { student: visibleUser }),
                        id: "TestScores",
                    }
                    : null,
                // @ts-expect-error - TS2322 - Type '{ tab: string; content: Element; id: string; } | null' is not assignable to type 'undefined'.
                canSeeTab("finances", tabPermissions, userIsOnCase, 
                // @ts-expect-error - TS2345 - Argument of type 'boolean | null | undefined' is not assignable to parameter of type 'boolean'.
                canSeeFullProfileForAllStudents, canSeeFullProfileForMyCaseload) && shouldSeeTab(Features.PROFILE_FINANCES, tabVisibility)
                    ? {
                        tab: "Finances",
                        content: (_jsx(AdvisorStudentsStudentFinancesTab, { student: visibleUser })),
                        id: "Finances",
                    }
                    : null,
                // @ts-expect-error - TS2322 - Type '{ tab: string; content: Element; id: string; } | null' is not assignable to type 'undefined'.
                canSeeTab("applications", tabPermissions, userIsOnCase, 
                // @ts-expect-error - TS2345 - Argument of type 'boolean | null | undefined' is not assignable to parameter of type 'boolean'.
                canSeeFullProfileForAllStudents, canSeeFullProfileForMyCaseload) && shouldSeeTab(Features.PROFILE_APPLICATIONS, tabVisibility)
                    ? {
                        tab: "Applications",
                        content: (_jsx(AdvisorStudentsStudentApplicationsTab, { student: visibleUser })),
                        id: "Applications",
                    }
                    : null,
                // @ts-expect-error - TS2322 - Type '{ tab: string; content: Element; id: string; } | null' is not assignable to type 'undefined'.
                canSeeTab("documents", tabPermissions, userIsOnCase, 
                // @ts-expect-error - TS2345 - Argument of type 'boolean | null | undefined' is not assignable to parameter of type 'boolean'.
                canSeeFullProfileForAllStudents, canSeeFullProfileForMyCaseload) && shouldSeeTab(Features.PROFILE_DOCS, tabVisibility)
                    ? {
                        tab: "Docs",
                        content: (_jsx(AdvisorStudentsStudentDocumentsTab, { student: visibleUser })),
                        id: "Docs",
                    }
                    : null,
                // @ts-expect-error - TS2322 - Type '{ tab: string; content: Element; id: string; } | null' is not assignable to type 'undefined'.
                canSeeTab("programs", tabPermissions, userIsOnCase, 
                // @ts-expect-error - TS2345 - Argument of type 'boolean | null | undefined' is not assignable to parameter of type 'boolean'.
                canSeeFullProfileForAllStudents, canSeeFullProfileForMyCaseload) && shouldSeeTab(Features.PROFILE_PROGRAMS, tabVisibility)
                    ? {
                        tab: "Programs",
                        content: _jsx(AdvisorStudentsProgramsTab, { student: visibleUser }),
                        id: "Programs",
                    }
                    : null,
                // @ts-expect-error - TS2322 - Type '{ tab: string; content: Element; id: string; } | null' is not assignable to type 'undefined'.
                canSeeTab("analytics", tabPermissions, userIsOnCase, 
                // @ts-expect-error - TS2345 - Argument of type 'boolean | null | undefined' is not assignable to parameter of type 'boolean'.
                canSeeFullProfileForAllStudents, canSeeFullProfileForMyCaseload) && shouldSeeTab(Features.PROFILE_ANALYTICS, tabVisibility)
                    ? {
                        tab: "Analytics",
                        content: (_jsx(AdvisorStudentsStudentAnalyticsTab, { student: visibleUser })),
                        id: "Analytics",
                    }
                    : null,
                // @ts-expect-error - TS2322 - Type '{ tab: string; content: Element; id: string; } | null' is not assignable to type 'undefined'.
                canSeeTab("pipelines", tabPermissions, userIsOnCase, 
                // @ts-expect-error - TS2345 - Argument of type 'boolean | null | undefined' is not assignable to parameter of type 'boolean'.
                canSeeFullProfileForAllStudents, canSeeFullProfileForMyCaseload) && shouldSeeTab(Features.PROFILE_PIPELINES, tabVisibility)
                    ? {
                        tab: "Pipelines",
                        content: (_jsx(AdvisorStudentsStudentPipelinesTab, { student: visibleUser, 
                            // @ts-expect-error - TS2322 - Type 'Opportunity | null | undefined' is not assignable to type 'Opportunity[] | null | undefined'.
                            opportunity: opportunity })),
                        id: "Pipelines",
                    }
                    : null,
                // @ts-expect-error - TS2322 - Type '{ tab: string; content: Element; id: string; } | null' is not assignable to type 'undefined'.
                canSeeTab("forms", tabPermissions, userIsOnCase, 
                // @ts-expect-error - TS2345 - Argument of type 'boolean | null | undefined' is not assignable to parameter of type 'boolean'.
                canSeeFullProfileForAllStudents, canSeeFullProfileForMyCaseload) && shouldSeeTab(Features.PROFILE_FORMS, tabVisibility)
                    ? {
                        tab: "Forms",
                        content: _jsx(AdvisorStudentsStudentFormsTab, { student: visibleUser }),
                        id: "Forms",
                    }
                    : null,
            ];
    }
};
export default getVisibleTabs;
